import styled from 'styled-components';

const Link = styled.a.attrs((props) => ({
  onClick: props.onClick,
  children: props.children,
  className: props.className,
  target: props.target,
  rel: props.rel,
  title: props.title,
}))`
  font-family: inherit;
  font-size: inherit;
  text-decoration: none;
  color: ${({ theme: { colors } }) => colors.blue};
  transition: ${({ theme: { transition } }) => transition};
  opacity: ${(props) => (props.disabled ? '0.5' : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover,
  &:focus {
    color: ${({ theme: { colors } }) => colors.blueHover};
  }
`;

export default Link;
